<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <v-card class="pa-6 rounded-xl" elevation="10">
      <v-card-title class="justify-center text-h6 font-weight-bold">
        Confirmación
      </v-card-title>

      <v-card-text class="text-subtitle-1 text-center py-6">
        ¿Estás seguro de realizar esta acción?
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn
          color="grey lighten-1"
          class="mx-2"
          rounded
          @click="emitir(false)"
        >
          Cancelar
        </v-btn>

        <v-btn
          color="primary"
          class="mx-2"
          rounded
          dark
          @click="emitir(true)"
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean
  },
  data() {
    return {};
  },
  methods: {
    emitir(confirmado) {
      this.$emit("reactivar", confirmado);
    }
  }
};
</script>
